module.exports = __webpack_public_path__ + "img/recovery-computer.7c16de82.png";